import { RootState } from "../store/community-finder-redux-store";

export const selectIsFirstSearchComplete = (state: RootState) =>
	state?.appStatus?.firstSearchComplete;